export default __webpack_public_path__ + "static/media/14 KYCDetails – 2@3x.520f37c1.png";